import { NavLink } from "react-router-dom";
import { FooterFirstSection, FooterSecondSection } from "./FooterStyles";
import Logo from "../../images/Globalmages/logo.svg";
import { useTranslation } from "react-i18next";
import { generateLink } from "../../functions/routingFuntion";
import { useAppSelector } from "../../store/hooks";

export const Footer = () => {
  const language = useAppSelector((state) => state.locale.localStorageValue);
  const { t } = useTranslation();

  return (
    <footer style={{ background: "#001b48", marginTop: "2.5rem" }}>
      <FooterFirstSection>
        <div className="first__line">
          <div>
            <NavLink to={generateLink("/", language)}>
              <img src={Logo} alt="LogoFooter" />
            </NavLink>
          </div>
          <div className="first__line__links">
            <NavLink to={generateLink("/", language)} target="_blanck">
              testemail@gmail.com
            </NavLink>
            <NavLink to={generateLink("/", language)} target="_blanck">
              {t("footer.blockInfo11")}
            </NavLink>
            <NavLink
              to={generateLink("/auth/login", language)}
              className="white__button flex__center"
            >
              {t("footer.blockInfo12")}
            </NavLink>
          </div>
        </div>
        <div className="second__line">
          <div className="second__line__container">
            <div className="second__line__info row">
              <div>
                <ul className="row">
                  <li className="first__li">
                    <NavLink to={generateLink("/terms", language)}>
                      {t("footer.blockInfo21")}
                    </NavLink>
                  </li>
                  <li className="first__li">
                    <NavLink to={generateLink("/market", language)}>
                      {t("footer.blockInfo22")}
                    </NavLink>
                  </li>
                  <li className="first__li">
                    <NavLink to={generateLink("/about-us", language)}>
                      {t("footer.blockInfo23")}
                    </NavLink>
                  </li>
                  <li className="first__li">
                    <NavLink to={generateLink("/contacts", language)}>
                      {t("footer.blockInfo24")}
                    </NavLink>
                  </li>
                </ul>
              </div>
              <div>
                <ul className="row">
                  <li className="second__li">
                    <NavLink to={generateLink("/", language)}>
                      {t("footer.blockInfo31")}
                    </NavLink>
                  </li>
                  <li className="second__li">
                    <NavLink to={generateLink("/", language)}>
                      {t("footer.blockInfo32")}
                    </NavLink>
                  </li>
                  <li className="second__li">
                    <NavLink to={generateLink("/", language)}>
                      {t("footer.blockInfo33")}
                    </NavLink>
                  </li>
                  <li className="second__li">
                    <NavLink to={generateLink("trade/faq", language)}>
                      {t("footer.blockInfo34")}
                    </NavLink>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </FooterFirstSection>
      <FooterSecondSection>
        <div className="second__section__container">
          <div className="first__text">
            <p>{t("footer.blockInfo41")}</p>
            <p>
              {t("footer.blockInfo42")} <br /> <br />
              {t("footer.blockInfo43")}
            </p>
          </div>
          <div className="second__text">
            <p>{t("footer.blockInfo44")}</p>
          </div>
        </div>
      </FooterSecondSection>
    </footer>
  );
};
